// 가입 폼의 Turnstile 자리 — 마운트될 때만 스크립트를 싣고 그린다 · resetKey 가 바뀌면 떼고 다시 그린다(토큰은 한 번 쓰면 끝).

import { useEffect, useRef } from "react";

import { mountTurnstile, type TurnstileFailure } from "@/lib/turnstile";

interface Props {
  siteKey: string;
  resetKey: number;
  // 둘 다 늘 같은 함수여야 한다(useState 의 setter) — 바뀌면 위젯을 다시 그린다.
  onToken: (token: string | null) => void;
  onFailedChange: (failure: TurnstileFailure | null) => void;
}

const TurnstileWidget = ({ siteKey, resetKey, onToken, onFailedChange }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    // 실패 뒤 위젯이 스스로 다시 풀어 토큰이 오면 실패 안내를 거둔다.
    const onTokenOrRecover = (token: string | null) => {
      onToken(token);
      if (token) onFailedChange(null);
    };
    return mountTurnstile(container, siteKey, { onToken: onTokenOrRecover, onFail: onFailedChange });
  }, [siteKey, resetKey, onToken, onFailedChange]);

  return <div className="min-h-16" data-testid="signup-turnstile" ref={ref} />;
};

export default TurnstileWidget;
